(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kjd-delivery-timeline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kjd-delivery-timeline')) {
    class KjdDeliveryTimeline extends HTMLElement {
      connectedCallback() {
        const parts = Object.fromEntries(
          new Intl.DateTimeFormat('en-US', {
            timeZone: 'America/New_York',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            hourCycle: 'h23'
          }).formatToParts(new Date()).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)])
        );
        const orderDate = new Date(Date.UTC(parts.year, parts.month - 1, parts.day));
        const isBusinessDay = date => date.getUTCDay() !== 0 && date.getUTCDay() !== 6;
        const addBusinessDays = (date, count) => {
          const next = new Date(date);
          let remaining = count;
          while (remaining > 0) {
            next.setUTCDate(next.getUTCDate() + 1);
            if (isBusinessDay(next)) remaining--;
          }
          return next;
        };
        let dispatchStart = new Date(orderDate);
        if (!isBusinessDay(dispatchStart) || parts.hour >= 15) {
          dispatchStart = addBusinessDays(dispatchStart, 1);
        }
        const deliveryStart = addBusinessDays(dispatchStart, 2);
        const deliveryEnd = addBusinessDays(dispatchStart, 4);
        const format = date => new Intl.DateTimeFormat('en-US', {
          month: 'short',
          day: 'numeric',
          timeZone: 'UTC'
        }).format(date);
        this.querySelector('[data-kjd-order]').textContent = format(orderDate);
        this.querySelector('[data-kjd-dispatch]').textContent = format(dispatchStart);
        this.querySelector('[data-kjd-delivery]').textContent = format(deliveryStart) + ' – ' + format(deliveryEnd);
      }
    }
    customElements.define('kjd-delivery-timeline', KjdDeliveryTimeline);
  }
  } catch(e) { console.error(e); }
})();

})();
